import * as imageCropper from '@zag-js/image-cropper';
import { normalizeProps, useMachine } from 'zag-ripple';
import { track } from 'ripple';

export component ImageCropper() {
	let service = useMachine(imageCropper.machine, {
		id: 'image-cropper',
		initialCrop: { x: 140, y: 170, width: 200, height: 150 },
	});
	let api = track(() => imageCropper.connect(service, normalizeProps));

	let previewUrl = track('');

    async function updatePreview() {
        // const dataUrl = await @api.getCroppedImage({
        //     output: "dataUrl",
        //     type: "image/png",
        // });

        // if (dataUrl) {
        //     @previewUrl = dataUrl;
        // }

    }

    function resetCrop() {
        @previewUrl = '';
    }

    if(!@previewUrl) {
        <div {...@api.getRootProps()}>
            <div {...@api.getViewportProps()}>
                <img
                    src="https://picsum.photos/seed/crop/640/400"
                    crossOrigin="anonymous"
                    {...@api.getImageProps()}
                />

                <div {...@api.getSelectionProps()}>
                    for (const position of imageCropper.handles; key position) {
                        <div {...@api.getHandleProps({ position })}>
                            <span />
                        </div>
                    }
                </div>
            </div>
        </div>
    }

    <div data-scope="image-cropper" data-part="br" />

    <div data-scope="image-cropper" data-part="preview">
        if(@previewUrl) {
            <div data-scope="image-cropper" data-part="preview-container">
                <img 
                    src={@previewUrl} 
                    alt="Cropped preview" 
                    data-scope="image-cropper"
                    data-part="preview-image"
                />
            </div>
        }
        
        <div data-scope="image-cropper" data-part="controls">
            <button onClick={@previewUrl ? resetCrop : updatePreview} data-scope="image-cropper" data-part="preview-button">
                {@previewUrl ? 'Reset Crop' : 'Crop Image'}
            </button>
        </div>
    </div>
}
